"use strict";

/**
 * Constantes para uso de campo de búsqueda.
 */
module.exports = {

    NOMBRE_PASIVO: 1,
    _CARGO_: 2,
    _ORGANISMO_: 3,
    _REGION_: 4,
    FECHA_INICIO: 5,
    FECHA_TERMINO: 6,
    COSTO: 7,
    DESTINO: 8,
    DATO_FINANCISTA: 9,
    PROPOSITO: 10,
    SINGULARIZACION: 11,
    OCASION: 12,
    NOMBRE_DONANTE: 13,
    OBSERVACION: 14,
    LUGAR: 15,
    NOMBRE_ASISTENTE: 16,
    MATERIA: 17,
    NOMBRE_ACTIVO: 18,
    TRABAJA_PARA: 19,
    NOMBRE_REPRESENTADO: 20
};


// WEBPACK FOOTER //
// ./src/busqueda/config/campo-busqueda.config.js